import {
  HeroSection,
  EcosystemGrid,
  TechnologySection,
  DisclaimerSection,
} from "@/components/home";
import Footer from "@/components/Footer";
import { useSeoMeta } from "@/hooks/useSeoMeta";

/**
 * 前台应用首页
 * Bento Grid 风格设计，展示品牌愿景和产品生态
 * 强制使用暗黑模式以保持视觉一致性
 */
export default function Home() {
  // 集成 SEO meta 标签管理
  useSeoMeta({ namespace: "home" });

  return (
    <div className="min-h-screen bg-zinc-950 dark" data-theme="dark">
      {/* Hero Section - 品牌愿景首屏 */}
      <HeroSection
        backgroundImage="/images/main-index.jpg"
        fallbackGradient="linear-gradient(180deg, rgba(0,20,40,1) 0%, rgba(0,10,20,1) 50%, rgba(0,5,15,1) 100%)"
      />

      {/* Ecosystem Grid - 功能矩阵 */}
      <EcosystemGrid />

      {/* Technology Section - 技术底座 */}
      <TechnologySection />

      {/* 免责声明 */}
      <DisclaimerSection />

      {/* 页脚 */}
      <div className="relative z-50">
        <Footer />
      </div>
    </div>
  );
}
